/* global modForm modUtils Modalytics */
import { getHeapSessionIdCookieData, initDuplicateSubmissionExperience, getPhoneAssignmentData } from '../helpers';
/**
 * Validate Zip Code
 * @param {String} zip - zip code to validate
 * @param {Function} callback - callback function after server response
 * @param {Boolean} [fromZipTracking=false] - A flag to indicate if the request is from zip tracking.
 * @param {Function} [abortCallback=null] - A callback function to execute if a `fromZipTracking` request is aborted.
 */
export function isZipCodeValid(zip, callback, fromZipTracking = false, abortCallback = null) {
	// Track the state of fromZipTracking requests
	if (fromZipTracking) {
		modForm.opts.zipTrackingState = { active: false, request: null, abortCallback: abortCallback };
	}

	const timeOut = modForm.opts.getVars && modForm.opts.getVars.timeout && modUtils.getEnv() !== 'production' ? Number(modForm.opts.getVars.timeout) : 3000,
		apiDomain = `https://${modUtils.getEnv() === 'production' ? 'hs.leadpost.net/' : 'hsleadpost1.quinstage.com/'}`,
		zipEditInput = document.querySelectorAll(modForm.zipEditInput)[0];
	const currentParams = modUtils.getUrlParamsToObject();
	const { phoneAssignmentConfig, quadLinkParams } = modForm.opts;
	const shouldCallPhoneAssignmentApi = phoneAssignmentConfig.showPhoneAssignmentNumber && !currentParams.startStep && (quadLinkParams && Object.keys(quadLinkParams).length) && modForm.opts.zipCode !== zip;

	// Create the request
	const request = new XMLHttpRequest();
	let response = {};
	request.open('GET', `${apiDomain}api/PostalCordinateInfo/${zip}/get`);
	request.timeout = timeOut;

	// Handle fromZipTracking logic
	if (fromZipTracking) {
		// Set the window variable to track the active request
		modForm.opts.zipTrackingState.active = true;
		modForm.opts.zipTrackingState.request = request;
	} else if (!fromZipTracking && modForm.opts.zipTrackingState.active) {
		// Abort the previous request if it was made with fromZipTracking = true
		modForm.opts.zipTrackingState.request.abort();
		modForm.opts.zipTrackingState.active = false;
		if (modForm.opts.zipTrackingState.abortCallback) {
			modForm.opts.zipTrackingState.abortCallback();
		}
	} else {
		// No active fromZipTracking request to abort
		modForm.opts.zipTrackingState.active = false;
		modForm.opts.zipTrackingState.request = null;
	}
	modForm.isZipValid = false;
	request.send();
	request.addEventListener('load', function() {
		if (this.response) {
			response = { ...response, ...JSON.parse(this.response) };
			if (this.readyState === 4 && this.status === 200) {
				response.success = true;
				response.data = JSON.parse(this.response);
				response.data.zip = zip;

				if (zipEditInput && zipEditInput.style.display === 'hidden') {
					document.querySelector(modForm.zipEditControlCls).style.display = 'block';
				}
				modForm.retryZipValidation = false;
				modForm.isZipValid = true;

				if ('function' === typeof callback) {
					callback(response);
				}

				if (shouldCallPhoneAssignmentApi) {
					getPhoneAssignmentData(modForm.opts.quadLinkParams, true);
				}
			} else {
				modForm.isZipValid = false;
				if ('function' === typeof callback) {
					if (response.status === 400) {
						callback({
							error: true,
							message: response.error_message
						});
					} else {
						callback({});
					}
				}
			}
		}
	});
	request.addEventListener('error', function() {
		console.error('Something went wrong');

		// Show duplicate submission fallback experience if API encounters network issues
		const heapSessionIdCookieData = getHeapSessionIdCookieData();
		initDuplicateSubmissionExperience(heapSessionIdCookieData);
		Modalytics.heap('track', ['API Error | Showing Fallback Experience', { function: 'isZipCodeValid' }]);
	});
	request.addEventListener('timeout', function() {
		modForm.retryZipValidation = true;
		if (modForm.opts.cityField[0]) {
			modForm.opts.cityField[0].value = '';
		}
		if (modForm.opts.stateField[0]) {
			modForm.opts.stateField[0].value = '';
		}
		if (document.querySelector(modForm.zipEditControlCls)) {
			document.querySelector(modForm.zipEditControlCls).style.display = 'none';
		}
		callback({ success: true, data: { zip: zip } });
	});
}
